export interface PaginatorData {
  current_page: number;
  data: any[];
  first_page_url: string;
  from: number;
  last_page: number;
  last_page_url: string;
  next_page_url: string;
  path: string;
  per_page: number;
  prev_page_url: string;
  to: number;
  total: number;
}

export class Paginator {
  public current_page: number;
  public data: any[];
  public first_page_url: string;
  public from: number;
  public last_page: number;
  public last_page_url: string;
  public next_page_url: string;
  public path: string;
  public per_page: number;
  public prev_page_url: string;
  public to: number;
  public total: number;


  public static fromAPI(data: PaginatorData): Paginator {
    return new Paginator(data);
  }

  constructor({current_page, data, first_page_url, from, last_page, last_page_url, next_page_url, path, per_page, prev_page_url, to, total}: PaginatorData) {
    this.current_page = current_page;
    this.data = data;
    this.first_page_url = first_page_url;
    this.from = from;
    this.last_page = last_page;
    this.last_page_url = last_page_url;
    this.next_page_url = next_page_url;
    this.path = path;
    this.per_page = per_page;
    this.prev_page_url = prev_page_url;
    this.to = to;
    this.total = total;
  }
}
